import React from "react";
import styled from "styled-components";
import { css } from "styled-components";
import isEmpty from "lodash/isEmpty";
// import "./styles.css";

// Components
import Spinner from "../../../components/Spinner";
import Card from "../../../components/Card";
import PaymentSchedule from "../../../components/PaymentSchedule";
import TripSummary from "../../../components/TripSummary";
import CheckCircleOutlineIcon from "../../../components/CheckCircleOutlineIcon";
import CardHeader from "../../../components/CardHeader";
import MediaQuery from "../../../components/MediaQuery";
// import ImportantInformation from "../../../components/ImportantInformation";
import ImportantInformationFlightLookup from "../../../components/ImportantInformationFlightLookup";
import ChargesSummaryTable from "../../../components/ChargesSummaryTable";

// Styled Components
const margin = "15px";
const BoldText = styled.span`
  font-weight: 600;
`;
const ResponsiveRow = styled.div`
  display: flex;
  margin-bottom: ${margin};
  width: 100%;

  ${MediaQuery.tablet`
    flex-direction: column;
  `};
`;
const responsiveRowFirstChildCSS = css`
  margin-right: ${margin};
  ${MediaQuery.tablet`
  margin-bottom: ${margin};
  margin-right: 0;
`};
`;
const ConfirmationWrapper = styled.div`
  flex: 0.6;
  text-align: center;
  ${responsiveRowFirstChildCSS};
`;
const PaymentHistoryWrapper = Card.extend`
  position: relative;
  flex: 0.4;
  text-align: center;
`;
const PaymentHistoryContent = styled.div`
  margin: 60px 0;
`;
const PaymentProgressBar = styled.div`
  border-radius: 2px;
  width: 100%;
  height: 20px;
  background: #e1eaff;
`;
const PaymentLevel = styled.div`
  border-radius: inherit;
  width: ${props => props.paymentPercentage}%;
  background: #00dfed;
  height: inherit;
`;
const TripSummaryWrapper = styled.div`
  flex: 0.7;
  ${responsiveRowFirstChildCSS};
`;
const ChargesSummaryWrapper = styled.div`
  flex: 0.3;
  white-space: nowrap;
`;
const textMargin = "7px";
const TripIdMsg = styled.div`
  margin: ${textMargin} 0;
`;
const TextWithMarginBottom = styled.div`
  margin-bottom: ${textMargin};
`;
const Text = styled.span`
  font-size: 1.6em;
`;
const Money = ({ amount }) => {
  return (
    <React.Fragment>
      $<Text>{amount}</Text>
    </React.Fragment>
  );
};
const AirlineContactHeader = styled.div`
  font-size: 22px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 10px;
`;
const AirlineContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0.3;
  margin-bottom: 15px;
  margin-right: 15px;
`;
const ImportantInformationWrapper = styled.div`
  flex: 0.7;
`;

const AirlineContactInfo = styled.div`
  margin-bottom: 15px;
`;
const AirlineContactInfoList = ({ airlineContacts }) => {
  return isEmpty(airlineContacts) ? (
    <Spinner />
  ) : (
    airlineContacts.map(airlineContact => (
      <AirlineContactInfo>
        <div>{airlineContact.name}</div>
        <div>{airlineContact.phoneNumber}</div>
        <div>{airlineContact.websiteUrl}</div>
        {/* <a href={`http://${airlineContact.websiteUrl}`}>{airlineContact.websiteUrl}</a> */}
        <div>Confirmation: {airlineContact.carrierLocator}</div>
      </AirlineContactInfo>
    ))
  );
};

const ReservationsPage = ({
  ppnTaxesAndFees,
  ppnBaseFare,
  ppnFees,
  fwdlookFees,
  importantInfoPopupData,
  airlineContacts,
  isSendingEmail,
  emailSentSuccessfully,
  paymentPercentage,
  totalPayments,
  departDateDisplay,
  returnDateDisplay,
  onSendConfirmationEmail,
  numberOfETickets,
  orderId,
  email,
  isRoundTrip,
  downPayment,
  departingTripSegments,
  returningTripSegments,
  installmentDates,
  installmentPayment,
  totalCost,
  isCostDetailsToggled
}) => (
  // <GreyBackgroundPage>
  <div>
    <ResponsiveRow>
      <ConfirmationWrapper>
        <Card>
          <CardHeader title="Trip Confirmation" />
          <CheckCircleOutlineIcon />
          <div>Your down payment of ${downPayment} was successful!</div>
          <TripIdMsg>
            Your reservation number is <BoldText> {orderId} </BoldText>
          </TripIdMsg>
          <TextWithMarginBottom>
            A confirmation email was sent to {email}
          </TextWithMarginBottom>
          <button
            onClick={isSendingEmail ? undefined : onSendConfirmationEmail}
            class={`btn btn-primary ${isSendingEmail ? "disabled" : ""}`}
          >
            {isSendingEmail
              ? "Sending Email..."
              : emailSentSuccessfully
                ? "Email Sent Successfully!"
                : "Resend Confirmation Email"}
          </button>
          {/* </div> */}
        </Card>
      </ConfirmationWrapper>

      <PaymentHistoryWrapper>
        <CardHeader title="Payment Summary" />
        <PaymentHistoryContent>
          <div> You have paid </div>
          <TextWithMarginBottom>
            <Money amount={totalPayments} /> of <Money amount={totalCost} />
          </TextWithMarginBottom>
          <PaymentProgressBar>
            <PaymentLevel paymentPercentage={paymentPercentage} />
          </PaymentProgressBar>
        </PaymentHistoryContent>
      </PaymentHistoryWrapper>
    </ResponsiveRow>

    <ResponsiveRow>
      <TripSummaryWrapper>
        <TripSummary
          {...{
            isRoundTrip,
            dateDisplayDepartingTrip: departDateDisplay,
            dateDisplayReturningTrip: returnDateDisplay,
            departingTripSegments,
            returningTripSegments
          }}
        />
      </TripSummaryWrapper>

      <ChargesSummaryWrapper>
        <Card>
          <CardHeader title="Charges Summary" />
          <ChargesSummaryTable
            {...{
              numberOfETickets,
              ppnTaxesAndFees,
              ppnBaseFare,
              ppnFees,
              fwdlookFees,
              // ppnTaxesAndFees: round(ppnTaxesAndFees),
              // ppnBaseFare: round(ppnBaseFare),
              // ppnFees: round(ppnFees),
              totalCost
              // fwdlookFees: round(fwdlookFees)
            }}
          />
          <PaymentSchedule
            installmentDates={installmentDates}
            installment={installmentPayment}
            totalCost={totalCost}
            // isCostDetailsToggled={isCostDetailsToggled}
            numberOfETickets={numberOfETickets}
          />
        </Card>
      </ChargesSummaryWrapper>
    </ResponsiveRow>
    <ResponsiveRow>
      <AirlineContactWrapper>
        <AirlineContactHeader>Airline Contact</AirlineContactHeader>
        <AirlineContactInfoList airlineContacts={airlineContacts} />
      </AirlineContactWrapper>
      <ImportantInformationWrapper>
        <ImportantInformationFlightLookup
          importantInfoPopupData={importantInfoPopupData}
        />
      </ImportantInformationWrapper>
    </ResponsiveRow>
  </div>
);

export default ReservationsPage;



// WEBPACK FOOTER //
// ./src/scenes/ReservationsPage/View/index.js